import { render, staticRenderFns } from "./Albums.vue?vue&type=template&id=38160c48&scoped=true"
import script from "./Albums.vue?vue&type=script&lang=js"
export * from "./Albums.vue?vue&type=script&lang=js"
import style0 from "./Albums.vue?vue&type=style&index=0&id=38160c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38160c48",
  null
  
)

export default component.exports